import { useUser } from '../contexts/UserContext';

export type ScanCredits = {
  /** Total credits available (monthly + surplus), or null when unknown. */
  total: number | null;
  /** Credit cost for the given feature, or null when unknown. */
  cost: number | null;
  /** True when the user cannot afford the feature. */
  outOfQuota: boolean;
  /** True when the user is on Plus/Premium (for tier-locked features). */
  isPlusOrPremium: boolean;
  /** Re-fetch balances after a metered action. */
  refreshCredits: () => Promise<void>;
};

/**
 * Shared credit gating for product-scanner style screens. Costs always come
 * from the API via the user context — never hardcoded.
 */
export default function useScanCredits(featureKey = 'product_barcode'): ScanCredits {
  const { credits, costFor, canAfford, refreshCredits } = useUser();
  const planName = (credits?.plan_name ?? '').toLowerCase();
  const isPlusOrPremium =
    planName.includes('plus') || planName.includes('premium') || planName.includes('pro');

  return {
    total: credits?.total ?? null,
    cost: costFor(featureKey),
    outOfQuota: !canAfford(featureKey),
    isPlusOrPremium,
    refreshCredits,
  };
}
